import {
  RECEIVE_USERINFO,
  RECEIVE_USERBASEINFO,
  RECEIVE_COUPONAMOUNT,
  RECEIVE_ADDRESSINFO,
  RECEIVE_PASSENGERINFO,
  RECEIVE_EXPRESSINFO,
  RECEIVE_OTHERRINFO,
  RECEIVE_TICKETINFO,
  RECEIVE_ORDERINFO,
  RECEIVE_BALANCEPAY,
  RECEIVE_FEE,
  RECEIVE_ADDFEE,
  RECEIVE_EXPRESSTYPE,
  RECEIVE_DOCTORINFO,
  RECEIVE_HOSPITALINFO,
  RECEIVE_PAYTYPE,
  RECEIVE_BUDGET
} from './mutation-type'

import {
  reqAddress,
  reqPassenger,
  reqBalancePay,
  reqWechatPay,
  reqAliPay,
  reqUserInfo,
  reqRecharge,
  reqOrderquery
} from '../api/index'

import {Message} from 'element-ui'
import Router from '../router'

export default {
  // 保存userInfo信息
  recordUserInfo ({commit}, userInfo) {
    commit(RECEIVE_USERINFO, userInfo)
  },
  // 清除userInfo信息
  clearCurrentState ({commit}) {
    commit(RECEIVE_USERINFO, {})
  },
  // 获取个人中心的用户基本信息
  async recordUserBaseInfo ({commit}, userBaseInfo) {
    let result = await reqUserInfo()
    if (result.code === 200) {
      let data = result.data.bussData
      let userInfo = {
        nickName: '', // 姓名
        sex: 1, // 性别
        mobile: '', // 手机号
        birthDay: '', // 生日
        area: '', // 城市
        occupation: '', // 职业
        mail: '', // 邮箱
        headImgUuid: '' // 头像
      }
      Object.keys(data).forEach(item => {
        userInfo[item] = data[item]
      })
      commit(RECEIVE_USERBASEINFO, userInfo)
      // this.$store.dispatch('recordUserBaseInfo',userInfo)
    }
  },

  // 获取个人中心的用户基本信息
  async getText ({commit}, textInfo) {
    let result = await reqUserInfo()
    if (result.code === 200) {
      let data = result.data.bussData
      let textInfo = {
        nickName: '', // 姓名
        sex: 1, // 性别
        mobile: '', // 手机号
        birthDay: '', // 生日
        area: '', // 城市
        occupation: '', // 职业
        mail: '', // 邮箱
        headImgUuid: '' // 头像
      }
      Object.keys(data).forEach(item => {
        textInfo[item] = data[item]
      })
      commit(RECEIVE_USERBASEINFO, textInfo)
      // this.$store.dispatch('recordUserBaseInfo',userInfo)
    }
  },
  // 修改发票额度
  changeInvoice ({commit}, invoice) {
    commit(RECEIVE_USERBASEINFO, invoice)
  },
  // 获取地址信息
  async getAddress ({commit}) {
    let result = await reqAddress()
    if (result.code === 200) {
      commit(RECEIVE_ADDRESSINFO, result.data.bussData)
    }
  },
  // 获取我的乘客信息
  async getPassenger ({commit}) {
    let result = await reqPassenger()
    console.log(result)
    if (result.code === 200) {
      commit(RECEIVE_PASSENGERINFO, result.data.bussData)
    }
  },
  // 获取快递信息
  getExpressInfo ({commit}, expressInfo) {
    commit(RECEIVE_EXPRESSINFO, expressInfo)
  },
  // 获取票务信息
  getTicketInfo ({commit}, ticketInfo) {
    commit(RECEIVE_TICKETINFO, ticketInfo)
  },
  // 清除票务信息
  clearTicketInfo ({commit}) {
    commit(RECEIVE_TICKETINFO, {})
  },
  // 获取其他信息
  getOtherInfo ({commit}, otherInfo) {
    commit(RECEIVE_OTHERRINFO, otherInfo)
  },
  // 获取订单信息
  getOrderInfo ({commit}, orderInfo) {
    commit(RECEIVE_ORDERINFO, orderInfo)
  },
  // 余额支付
  async getBalancePay ({commit}, query) {
    let result = await reqBalancePay(query)
    console.log(result)
    if (result.code === 200) {
      commit(RECEIVE_BALANCEPAY, result)
      Router.push('/success')
    } else if (result.code === 500) {
      Message({
        message: result.data.errMsg,
        type: 'error'
      })
    }
  },
  // 微信支付
  async getWechatPay ({commit}, query) {
    let result = await reqWechatPay(query)
    if (result.code === 200) {
      commit(RECEIVE_BALANCEPAY, result.data.bussData)
      let res = await reqOrderquery(query)
      if (res.code === 200) {
        if (res.data.bussData.trade_state === 'SUCCESS') {
          Router.replace('/success')
        }
      }
    }
  },
  // 支付宝支付
  async getAliPay ({commit}, query) {
    let result = await reqAliPay(query)
    console.log(result)
    if (result.code === 200) {
      document.querySelector("body").innerHTML = result.data.bussData;
      document.forms[0].submit();
      commit(RECEIVE_BALANCEPAY, result.data.bussData)
      // Router.push('/sucess')
    }
  },
  // 订单充值
  async getRecharge ({commit}, query) {
    let result = await reqRecharge(query)
    console.log(result)
    if (result.code === 200) {
      commit(RECEIVE_ORDERINFO, result.data.bussData)
    }
  },
  // 保存优惠券价格
  clearCouponAmount ({commit}) {
    commit(RECEIVE_COUPONAMOUNT, {amount: 0})
  },
  //  清空优惠券
  getCouponAmount ({commit}, amount) {
    commit(RECEIVE_COUPONAMOUNT, amount)
  },
  // 服务费和夜间费用
  getFee ({commit}, fee) {
    commit(RECEIVE_FEE, fee)
  },
  // 清空服务费和夜间费用
  clearFee ({commit}) {
    commit(RECEIVE_FEE, {serviceFee: 0})
  },
  // 保存估计车费
  getBudget ({commit}, budget) {
    commit(RECEIVE_BUDGET, budget)
  },
  // 清除估计车费
  clearBudget ({commit}) {
    commit(RECEIVE_BUDGET, 0)
  },
  // 加价
  getAddFee ({commit}, addFee) {
    commit(RECEIVE_ADDFEE, addFee)
  },
  // 清空加价
  clearAddFee ({commit}) {
    commit(RECEIVE_ADDFEE, 0)
  },
  // 快递类型
  getExpressType ({commit}, expressType) {
    commit(RECEIVE_EXPRESSTYPE, expressType)
  },
  // 医生信息
  getDoctorInfo ({commit}, doctorInfo) {
    commit(RECEIVE_DOCTORINFO, doctorInfo)
  },
  // 医院信息
  getHospitalInfo ({commit}, hospitalInfo) {
    commit(RECEIVE_HOSPITALINFO, hospitalInfo)
  },
  // 支付方式
  getPayType ({commit}, payType) {
    commit(RECEIVE_PAYTYPE, payType)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js